<template>
  <div class="bonus" v-if="app!=null && app.data !=null">
    <div class="launcher" id="bonus-content">
      <div @click="app.displaySettings()" id="boule" class="new-boule"><svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"  style="fill: rgb(128, 151, 13);"><path d="M130.001-254.616V-300h699.998v45.384H130.001Zm0-202.692v-45.384h699.998v45.384H130.001Zm0-202.692v-45.384h699.998V-660H130.001Z"/></svg></div>
      <h1>Bonus</h1>

      <div id="hidden-img">
        <div @click="app.displaySettings()" id="hidden-boule">=</div>
        <div @click="app.displayBonusDesc()" id="i"><img id="bulb" src="bulb.png"></div>
        <div @click="app.closeBonus()" id="zoom"><img id="eye" src="eye.png"></div>
        <div v-for="bonus in app.data[app.currentMusee].bonus.filter(x => x.id == app.currentQuizz)" :key="bonus">
          <img id="bg-img" :src="bonus.img_focus" />
          <div id="desc">
            <img id="line" class="line" src="line.png">
            <div @click="app.removeBonusDesc()" id="close-desc"><img src="arrows/white-arrow-bot.png"></div>
            <p>{{bonus.infoText}}</p>

          </div>
        </div>
      </div>

      <div id="bonus-selector">
        <img id="line" src="line.png">
        
        <h3>Rien que pour vos yeux !</h3>
        <p>Une oeuvre que vous ne verrez jamais dans le musée car elle doit rester en réserve pour des raisons de fragilité.</p>
        <button @click="app.displayBonus()">Découvrir</button>
      </div>
    </div>

    <zoom
          v-bind:app="app"
    ></zoom>
    
    <settings
          v-bind:app="app"
    ></settings>



  </div>
</template>

<script>
import zoom from './zoom.vue';
import settings from './settings.vue';

export default {
  name: 'BonusVue',
  props: {
    app:Object
  },
  components :{
    zoom,
    settings
  }
}
</script>


